import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section, ReqTable } from "./LegalLayout";

const Terms = () => (
  <LegalLayout title="Публичная оферта" updated="14 июня 2026 г.">
    <p style={{ fontSize: "0.88rem", color: "rgba(0,0,0,0.55)", marginBottom: "2rem" }}>
      Исполнитель: ИП КОКОВ АЛЕКСАНДР ДМИТРИЕВИЧ, ОГРНИП: 325784700333162,
      ИНН: 784302022304, адрес: Россия, г. Санкт-Петербург, пос. Комарово,
      Цветочная 2А
    </p>

    <Section title="1. Общие положения">
      <p>
        Настоящий документ является публичной офертой (далее — «Оферта») в
        соответствии со ст. 435–444 Гражданского кодекса РФ. Оплата услуги
        считается акцептом Оферты. Принятие Оферты означает согласие с её
        условиями в полном объёме.
      </p>
      <p>
        Исполнитель вправе в одностороннем порядке изменять условия Оферты
        путём публикации новой редакции на сайте <strong>swingmentor.pro</strong>.
        Изменения не распространяются на уже оплаченные услуги.
      </p>
    </Section>

    <Section title="2. Предмет договора">
      <p>
        Исполнитель предоставляет Заказчику доступ к онлайн-сервису{" "}
        <strong>SwingMentor</strong> (сайт <strong>swingmentor.pro</strong>) —
        сервису автоматизированного анализа техники гольф-свинга по
        загружаемым видеозаписям с использованием технологий искусственного
        интеллекта. В рамках оплаченного тарифа Заказчик получает:
      </p>
      <ul>
        <li>возможность загрузки видеозаписей свинга и их автоматический анализ;</li>
        <li>персональные рекомендации по технике на основе анализа;</li>
        <li>пакет кредитов на анализ согласно выбранному тарифу;</li>
        <li>доступ к истории своих анализов в личном кабинете;</li>
        <li>доступ к функциям ИИ-наставника (AI-коучинг).</li>
      </ul>
      <p>
        Кредит — внутренняя расчётная единица сервиса, списываемая при
        выполнении анализа. Новым пользователям бесплатно начисляется 30
        кредитов.
      </p>
    </Section>

    <Section title="3. Стоимость и порядок оплаты">
      <ReqTable
        rows={[
          ["SwingMentor Pro — 1 месяц", "899 ₽ (500 кредитов)"],
          ["SwingMentor Pro — 1 год", "8 990 ₽ (6 000 кредитов)"],
          ["SwingMentor Premium — 1 месяц", "1 799 ₽ (1 500 кредитов)"],
          ["SwingMentor Premium — 1 год", "17 990 ₽ (18 000 кредитов)"],
        ]}
      />
      <p>
        НДС не облагается в связи с применением Исполнителем упрощённой
        системы налогообложения. Оплата производится единовременно банковской
        картой через платёжный сервис ЮKassa (ООО НКО «ЮМани») либо, для
        международных пользователей, криптовалютой через платёжный сервис
        Trybit. Автоматическое продление и автосписания не применяются: по
        окончании оплаченного периода доступ к тарифу прекращается, аккаунт
        переходит на бесплатный план.
      </p>
      <p>
        Доступ к тарифу и кредиты предоставляются автоматически после
        подтверждения оплаты. Исполнитель применяет контрольно-кассовую
        технику и направляет кассовый чек на e-mail Заказчика в соответствии с
        Федеральным законом от 22.05.2003 № 54-ФЗ.
      </p>
    </Section>

    <Section title="4. Возврат денежных средств">
      <p>
        Заказчик вправе отказаться от услуги и получить полный возврат
        средств, если кредиты оплаченного тарифа{" "}
        <strong>не были использованы</strong> (не выполнено ни одного анализа
        за счёт оплаченного пакета). Для этого направьте заявку на{" "}
        <a href="mailto:info@swingmentor.pro">info@swingmentor.pro</a> в
        течение 14 дней с даты оплаты.
      </p>
      <p>
        После начала использования оплаченного пакета возврат возможен
        пропорционально неиспользованной части периода и кредитов, за вычетом
        фактически понесённых Исполнителем расходов (ст. 782 ГК РФ, ст. 32
        Закона о защите прав потребителей). Заявки рассматриваются в течение
        10 рабочих дней.
      </p>
    </Section>

    <Section title="5. Права и обязанности сторон">
      <p><strong>Заказчик обязуется:</strong></p>
      <ul>
        <li>предоставлять достоверную информацию при регистрации и оплате;</li>
        <li>
          загружать только те видеозаписи, на которые имеет законные права и
          на публикацию которых имеет согласие изображённых лиц (ст. 152.1 ГК
          РФ);
        </li>
        <li>не размещать материалы, нарушающие законодательство РФ;</li>
        <li>не передавать доступ к аккаунту третьим лицам.</li>
      </ul>
      <p><strong>Исполнитель обязуется:</strong></p>
      <ul>
        <li>
          обеспечить доступность сервиса не менее 99% времени (за исключением
          плановых технических работ);
        </li>
        <li>
          обеспечить конфиденциальность персональных данных согласно{" "}
          <Link to="/legal/privacy">Политике конфиденциальности</Link>;
        </li>
        <li>начислить оплаченные кредиты в полном объёме после подтверждения оплаты.</li>
      </ul>
    </Section>

    <Section title="6. Контент и интеллектуальная собственность">
      <p>
        Видеозаписи, загружаемые Заказчиком, остаются его собственностью.
        Исполнитель получает неисключительное право использовать их
        исключительно в целях оказания услуги (выполнение анализа).
      </p>
      <p>
        Исходная видеозапись и создаваемые при обработке временные файлы хранятся
        только на период выполнения анализа, включая предусмотренные сервисом
        повторные попытки, и удаляются после успешного завершения анализа либо
        его окончательного завершения с ошибкой. Временная копия на отдельном
        вычислительном узле удаляется после завершения каждой попытки обработки.
      </p>
      <p>
        Обработанное видео сохраняется в истории аккаунта только при включённой
        пользователем настройке хранения видео. Оно хранится до отключения этой
        настройки или удаления аккаунта. Текстовые результаты анализа, оценки,
        рекомендации и изображения фаз свинга хранятся в истории до удаления
        аккаунта либо до исполнения подтверждённого запроса Заказчика на
        удаление. Сведения, которые Исполнитель обязан хранить по закону,
        удалению по такому запросу не подлежат до истечения обязательного срока.
      </p>
      <p>
        Результаты анализа носят рекомендательный характер, не являются
        медицинской или профессиональной тренерской консультацией и не
        гарантируют достижения спортивных результатов.
      </p>
    </Section>

    <Section title="7. Ответственность">
      <p>
        Ответственность Исполнителя по настоящему договору ограничена суммой,
        уплаченной Заказчиком за услугу. Исполнитель не несёт ответственности
        за работу сторонних сервисов (платёжные системы, провайдеры связи) и
        технические сбои, находящиеся вне его контроля.
      </p>
    </Section>

    <Section title="8. Информация об Исполнителе (ст. 9–10 ЗоЗПП)">
      <ReqTable
        rows={[
          ["Исполнитель", "ИП Коков Александр Дмитриевич"],
          ["ОГРНИП", "325784700333162"],
          ["ИНН", "784302022304"],
          ["Адрес", "Россия, г. Санкт-Петербург, пос. Комарово, Цветочная 2А"],
          ["E-mail", "info@swingmentor.pro"],
          ["Телефон", "+7 999 032-27-57"],
          ["Режим работы", "Пн–Пт, 10:00–19:00 МСК"],
        ]}
      />
    </Section>

    <Section title="9. Уведомление об обработке персональных данных">
      <p>
        При регистрации, оплате и загрузке видеозаписей осуществляется
        обработка персональных данных согласно{" "}
        <Link to="/legal/privacy">Политике конфиденциальности</Link> и{" "}
        <Link to="/legal/consent">Согласию на обработку персональных данных</Link>.
        Исполнитель направил уведомление об обработке персональных данных в
        Роскомнадзор в соответствии со ст. 22 Федерального закона № 152-ФЗ.
      </p>
      <p>
        Первичная запись, систематизация, накопление и основное хранение
        персональных данных осуществляются в базах данных на территории
        Российской Федерации. Для выполнения анализа видеозапись может
        временно передаваться на отдельный вычислительный узел, в том числе за
        пределами Российской Федерации, без передачи вместе с ней имени,
        адреса электронной почты и платёжных сведений Заказчика. Временная
        копия удаляется после завершения попытки обработки.
      </p>
    </Section>

    <Section title="10. Разрешение споров">
      <p>
        Споры разрешаются путём переговоров. При невозможности — в суде по
        месту нахождения Исполнителя (если Заказчик является юридическим
        лицом) или по месту жительства Заказчика (если Заказчик является
        потребителем в соответствии с Законом о защите прав потребителей).
      </p>
    </Section>
  </LegalLayout>
);

export default Terms;
